import marketReports from './market-reports';
import researchLibrary from './research-library';
import customExports from './custom-exports';
import customReports from './custom-reports';
import kpiForecasts from './kpi-forecasts';
import axios, { buildRequestCancelation } from '../../../configs/axios';

export default {
  marketReports,
  customExports,
  researchLibrary,
  customReports,
  kpiForecasts,
  buildRequestCancelation,
  isCancel: axios.isCancel,
};
